/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<path pid="0" d="M29 177.4h198v42.4H29zM29 106.7h198v42.4H29zM29 36h198v42.4H29z"/>'
  }
})
